import ProjectVariation from "../types/ProjectVariation";
import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProjectVariationCounts = (
    token: string,
    backend: string,
    projectId?: number,
    search?: string
) => {
    return fetch(
        `${getApiUrl(backend)}project_variation_counts/?${projectId ? 'projectId='+ projectId : ""}${search ? '&search='+ search : ""}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            }
        }
    );
};

export default getProjectVariationCounts;
